<template>
  <div :class="classes">
    <div class="vi-help-guide-video-item--img" @click="onPlay">
      <div class="vi-help-guide-video-item--img__cover">
        <i class="fa fa-play-circle" aria-hidden="true" />
      </div>
      <img :src="videoImg()" alt="" width="188" height="110">
    </div>
    <el-dialog title="提示" :visible.sync="isVideo" width="540px" append-to-body :before-close="onPlayClose">
      <div v-if="isVideo">
        <video id="video1" class="video-js vjs-default-skin" :poster="showImg2(item.resCover)" controls preload="none" width="500" height="320" style="margin-top: -16px" >
          <source :src="item.content" type="video/mp4">
        </video>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  const prefixCls = 'vi-help-guide-video-item'

  export default {
    name: 'vi-help-guide-video-item',
    data () {
      return {
        isVideo: false,
        videoJs: {}
      }
    },
    props: {
      item: {
        type: Object,
        default: () => {}
      }
    },
    methods: {
      videoImg () {
        return `${global.domainImg()}${this.item.resCover}`
      },
      onPlay () {
        this.isVideo = true
        setTimeout(() => {
          this.videoJs = window.videojs(`video1`, { muted: true, controls: true, height: 320, width: 500, loop: true })
        }, 1)
      },
      onPlayClose () {
        this.videoJs.dispose()
        this.isVideo = false
      }
    },
    watch: {},
    beforeCreate () {
    },
    created () {
    },
    beforeMount () {
    },
    mounted () {
    },
    beforeUpdate () {
    },
    updated () {
    },
    beforeDestroy () {

    },
    destroyed () {
    },
    computed: {
      classes () {
        return [
          `${prefixCls}`
        ]
      }
    },
    components: {}
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  $-prefix-cls: "vi-help-guide-video-item";
  .#{$-prefix-cls} {
    width:188px;
    height: 110px;
    cursor: pointer;
    border-radius:6px;
    margin-bottom: 10px;
    &--img {
      width:188px;
      height: 110px;
      position: relative;
      z-index: 1;
      overflow: hidden;
      border-radius:6px;
      &__cover {
        width:188px;
        height: 110px;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        color: #aaa;
        opacity: 0;
        background: rgba(0,0,0,.3);
        transition: all ease-in-out 0.3s;
        text-align: center;
        line-height: 120px;
        >i {
          font-size: 40px;
          color: #fff;
          transform: scale(1.4);
          transition: all ease-in-out 0.3s;
        }
      }
      >img {
        transform: scale(1);
        border-radius:6px;
        transition: all ease-in-out 0.3s;
      }
    }
    &:hover {
      .#{$-prefix-cls}--img {
        img {
          transform: scale(1.1);
          filter: blur(2px);
          transition: all ease-in-out 0.3s;
        }
        &__cover {
          transition: all ease-in-out 0.3s;
          opacity: 1;
          >i {
            opacity: .8;
            transform: scale(1);
            transition: all ease-in-out 0.3s;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/js/module/layout/_source/helpGuideVideoItem.vue